import { useEffect, useRef } from "react";

export default function SalesforceMessaging() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const initEmbeddedMessaging = () => {
      try {
        if (!window.embeddedservice_bootstrap) return;

        window.embeddedservice_bootstrap.settings.language = "en_US";

        window.embeddedservice_bootstrap.init(
          "00D1a000000aEOE",
          "Cloud_Agent_Suite_Messaging_for_Web",
          "https://lonewolf.my.site.com/ESWCloudAgentSuiteMess1762371822979",
          {
            scrt2URL: "https://lonewolf.my.salesforce-scrt.com"
          }
        );
      } catch (err) {
        console.error("Error loading Embedded Messaging:", err);
      }
    };

    const script = document.createElement("script");
    script.src =
      "https://lonewolf.my.site.com/ESWCloudAgentSuiteMess1762371822979/assets/js/bootstrap.min.js";
    script.async = true;
    script.onload = initEmbeddedMessaging;

    document.body.appendChild(script);

    return () => {
      hasInitialized.current = false;
    };
  }, []);

  return null;
}
